import React from 'react';
import Styled from './index.styled';
import Typography from '../Typography';
import Fade from 'react-reveal/Fade';
import { useMobileBreakpoint } from '../breakpoints';
import { animated, useSpring } from 'react-spring';
import fingerprint from './fingerprint.png';
import { useTranslation } from 'react-i18next';

const FadeIn = (props) => <Fade distance="100px" {...props} /> 

const PageHero = () => {
  const isMobile = useMobileBreakpoint();
  const { t } = useTranslation();
  const background = t(`HeroData.background`, {returnObjects: true});

  const leftProps = useSpring({
    delay: 500,
    from: {
      transform: 'translate3d(-200px, 0px, 0px)',
      opacity: 0,
    },
    to: {
      transform: 'translate3d(0px, 0px, 0px)',
      opacity: 1,
    }
  });

  const rightProps = useSpring({
    delay: 500,
    from: {
      transform: 'translate3d(200px, 0px, 0px) rotate(180deg)',
      opacity: 0,
    },
    to: {
      transform: 'translate3d(0px, 0px, 0px) rotate(180deg)',
      opacity: 1,
    }
  });

  return (
    <Styled.Wrapper>
      <Styled.Image>
        {
          isMobile &&
          <img src={require(`${background.mobile}`).default} alt="" role="presentation" />
        }
      </Styled.Image>
      {
        !isMobile &&
        <>
          <Styled.Fingerprint>
            <animated.img src={fingerprint} alt="" role="presentation" style={leftProps} />
          </Styled.Fingerprint>
          <Styled.FingerprintRight>
            <animated.img src={fingerprint} alt="" role="presentation" style={rightProps} />
          </Styled.FingerprintRight>
        </>
      }
      <Styled.Content>
        <FadeIn up delay={500}>
          <Styled.Heading1>{t('HeroData.heading')}</Styled.Heading1>
          <Typography.Body as="p">{t('HeroData.description')}</Typography.Body>
        </FadeIn>
      </Styled.Content>
    </Styled.Wrapper>
  );
};

export default PageHero;
